import { render, staticRenderFns } from "./trainingAction.vue?vue&type=template&id=961fc054&scoped=true&"
import script from "./trainingAction.vue?vue&type=script&lang=js&"
export * from "./trainingAction.vue?vue&type=script&lang=js&"
import style0 from "./trainingAction.vue?vue&type=style&index=0&id=961fc054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961fc054",
  null
  
)

export default component.exports